import {
    type EmploymentStatus,
    type InsuranceCoverage,
    type InvestmentType,
    type TaxFiling,
} from '@fruitful/types';

import type { Address } from './Address';

export enum Pronouns {
    HE_HIM = 'He / Him',
    SHE_HER = 'She / Her',
    THEY_THEM = 'They / Them',
    OTHER = 'Other',
}

export enum UserType {
    PRIMARY_MEMBER = 'PRIMARY_MEMBER',
    PARTNER_MEMBER = 'PARTNER_MEMBER',
    JOINT_ACCOUNT_HOLDER = 'JOINT_ACCOUNT_HOLDER',
    PROSPECT = 'PROSPECT',
}

export enum KYCVerificationStatus {
    UNVERIFIED = 'UNVERIFIED',
    PENDING = 'PENDING',
    PROVISIONAL = 'PROVISIONAL',
    ACCEPTED = 'ACCEPTED',
    REVIEW = 'REVIEW',
    VENDOR_ERROR = 'VENDOR_ERROR',
    REJECTED = 'REJECTED',
}

export interface User {
    id: string;
    type: UserType;
    email: string;
    firstName: string | null;
    lastName: string | null;
    pronouns: string | null;
    dateOfBirth: string | null;
    taxFiling: TaxFiling | null;
    employmentStatus: EmploymentStatus | null;
    insuranceCoverage: InsuranceCoverage[];
    investments?: InvestmentType[];
    userAddress: Address | null;
    syncteraKycStatus: KYCVerificationStatus | null;
}

export interface Guide {
    id: string;
    firstName: string;
    lastName: string;
    profileImageUrl?: string | null;
}

export interface Membership {
    id: string;
    guideId?: string | null;
    createdAt: string;
    guide?: Guide | null;
    users: User[];
}
